import { bindUrl, request } from "./request";
/**
 * 三级地址树
 * GET /oil/location/list
 */
export function getLocationList() {
  return request({
    url: bindUrl("/blade-system/region/lazy-tree", {}),
    method: "GET"
  });
}
